import { render, staticRenderFns } from "./VideoReviewPanel.vue?vue&type=template&id=4d9296d8&scoped=true&"
import script from "./VideoReviewPanel.vue?vue&type=script&lang=js&"
export * from "./VideoReviewPanel.vue?vue&type=script&lang=js&"
import style0 from "./VideoReviewPanel.vue?vue&type=style&index=0&id=4d9296d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9296d8",
  null
  
)

export default component.exports